export const Bio = {
  name: "Sujal Jain",
  roles: ["Frontend Developer", "UI/UX Designer", "Programmer"],
  description:
    "I am a passionate software developer with strong experience in building modern, scalable applications and a keen interest in security focused solutions. I enjoy working across the full development lifecycle from designing system architecture to implementing clean, user friendly interfaces. I am always eager to learn new technologies, solve real world problems, and build products that are reliable, secure, and impactful.",
  github: "https://github.com/Sujal942",
  email: "sujaljain5555@gmail.com",
  resume:
    // "https://drive.google.com/file/d/15ibPhg246NGB90Ch0JeIzVw3JQQaDrcW/view?usp=sharing",
    // "https://drive.google.com/file/d/1KEu2aHsdMmdv44DVHsCFMZYTywQ1vIxV/view?usp=sharing",
    "https://drive.google.com/file/d/1LUsA49HguJT_rme6XcO2DEFdkx1UxJK0/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sujal-jain-a7a34b1a6/",
  twitter: "https://x.com/SujalJa13973286",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "https://imgs.search.brave.com/hOXHjsHEaEm2Bw5HYTfKBpYlTscAZEz0Djit6KAoGhU/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvY2ExYWM3ZjNi/YmYyMjJmZGJhZGE5/Y2JjYjgxZmY1YmM1/Y2M0YzRiNTFhMWQ4/N2ZiMzM4NGZmNThi/OWIwY2IzYS9uZXh0/anMub3JnLw",
      },
      {
        name: " Three JS",
        image:
          "https://imgs.search.brave.com/UDCwGNjUpDdP3gybRlFfd96xeZNHAZ2A9-VhkyZBink/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy90/aHVtYi8zLzNmL1Ro/cmVlLmpzX0ljb24u/c3ZnLzI1MHB4LVRo/cmVlLmpzX0ljb24u/c3ZnLnBuZw",
      },
      {
        name: "Streamlit",
        image:
          "https://imgs.search.brave.com/Xa75rcTJ6kvkMo42I3RifBUJv0jweUDYTdkxin5DKOM/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9taXJv/Lm1lZGl1bS5jb20v/djIvMSp5Yzh2OVlz/UU1nOWgtbS11bmVZ/TElRLnBuZw",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://imgs.search.brave.com/ZntqSD-VSL9wlrIRgTyyNtbfYvdEjbjppqOS1Fx63YA/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy90/aHVtYi9hL2FiL09m/ZmljaWFsX0NTU19M/b2dvLnN2Zy8yNTBw/eC1PZmZpY2lhbF9D/U1NfTG9nby5zdmcu/cG5n",
      },
      {
        name: "Tailwind",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNhoXisDruJMDAq3Ltd-wuaMW2lGxck9wAKw&s",
      },
      {
        name: "Redux",
        image:
          "https://imgs.search.brave.com/SEKt2j0cJdfCENRuRbUAzVHs-I0Hmja0fekGeUXk7OE/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL2dp/bGJhcmJhcmEvbG9n/b3MvbWFpbi9sb2dv/cy9yZWR1eC5zdmc",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://imgs.search.brave.com/uzBEWUQpFBVHe8GBbLviytYul-EfbZtlygcptIaU8io/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/aWNvbnM4LmNvbS8_/c2l6ZT0xMjAwJmlk/PVNEVm10WjZWQkdY/dCZmb3JtYXQ9anBn",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Supabase",
        image:
          "https://imgs.search.brave.com/K_x9U2H_h5RJcwTz2xQGbJqhfpoXOSZDSiwH8mqrosI/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/YnJhbmRmZXRjaC5p/by9pZHNTY2VHOGZL/L3cvNDM2L2gvNDQ5/L3RoZW1lL2Rhcmsv/c3ltYm9sLnBuZz9j/PTFieGlkNjRNdXA3/YWN6ZXdTQVlNWCZ0/PTE2NjgwODE0OTc1/MTc",
      },
      {
        name: "SQLite",
        image:
          "https://imgs.search.brave.com/DoWo1qntwk4JbsaY4cvTsX4AD_hhzppoglcntKPTCJM/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy85/Lzk3L1NxbGl0ZS1z/cXVhcmUtaWNvbi5z/dmc",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "JavaScript",
        image:
          "https://imgs.search.brave.com/2Lop95efMN3mNn8YORMHw4gXlmuiYbR1SXVpQQV4NCo/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy90/aHVtYi85Lzk5L1Vu/b2ZmaWNpYWxfSmF2/YVNjcmlwdF9sb2dv/XzIuc3ZnLzI1MHB4/LVVub2ZmaWNpYWxf/SmF2YVNjcmlwdF9s/b2dvXzIuc3ZnLnBu/Zw",
      },
      {
        name: "Python",
        image:
          "https://imgs.search.brave.com/Gc4o0TZByHDXOrUog0t60tOvt-BmVp3pOLjo8FdPnCM/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9hc3Nl/dHMuc3RpY2twbmcu/Y29tL2ltYWdlcy81/ODQ4MTUyZmNlZjEw/MTRjMGI1ZTQ5Njcu/cG5n",
      },
      {
        name: "C++",
        image:
          "https://imgs.search.brave.com/TC4R7mLgjO2ZPOLBKROQsPlt-c2NQWhwb6gp_QwdyOo/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy8x/LzE4L0lTT19DKytf/TG9nby5zdmc",
      },
      {
        name: "Rust",
        image:
          "https://imgs.search.brave.com/mVPGx-09945W3sWVfieylF3WqEbszZSr2VD7Fw51ozw/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pY29u/cy52ZXJ5aWNvbi5j/b20vcG5nL28vYnVz/aW5lc3MvdnNjb2Rl/LXByb2dyYW0taXRl/bS1pY29uL3J1c3Qt/MS5wbmc",
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "Git",
        image: "https://avatars.githubusercontent.com/u/18133?s=200&v=4",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Postman",
        image:
          "https://imgs.search.brave.com/SwbSEY2oSPa4qv6shk3g7DAn5ir9w0SYJ3FJrlraRUk/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9maWxl/cy5icmFuZGxvZ29z/Lm5ldC9zdmcvSnNS/SWJOaWlpcy9wb3N0/bWFuLWxvZ28tYnJh/bmRsb2dvcy5uZXRf/cTJ6dDNlaGNlLnN2/Zw",
      },
      {
        name: "Oracle Apex",
        image:
          "https://imgs.search.brave.com/ao04aH6U1uYGtL57Rg6uA0i98zLwFjjs8iJL5X-3loQ/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9wcm9k/LXN0YXRpYy51cy1z/ZWEtMS5saW5vZGVv/YmplY3RzLmNvbS9w/cm9kdWN0cy9sb2dv/cy8xMmNhNmM5OS01/Y2Q4LTQ3NjMtYWY0/Yy1lOTVkYWI2YmI4/M2Euc3Zn",
      },
      {
        name: "Netlify",
        image:
          "https://imgs.search.brave.com/_f84w-K3P32DdZVxBj9ga2tva6w0H3oh-Bgy6Ix48vI/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly93d3cu/c3ZncmVwby5jb20v/c2hvdy8zNzYzMzkv/bmV0bGlmeS5zdmc",
      },
      {
        name: "Vercel",
        image:
          "https://imgs.search.brave.com/QOFXzOARkwgOyAOCtTTRGQVA7kCunGle7p-L7P-Ysck/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL3dp/dGhhc3Ryby9kb2Nz/L21haW4vcHVibGlj/L2xvZ29zL3ZlcmNl/bC5zdmc",
      },
      {
        name: "Render",
        image:
          "https://imgs.search.brave.com/iUIiF_cAk0r_1kJIy86Pm60sPFTqbGRgFliHYBjXTUA/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvOTkyYjU4ODU5/NGVkMzFhYTA3Mzg3/N2UwZjZjNzQ3ZTc0/MjE2NmU3YjhlZWNi/MGFjNWRjYTJmNjA5/NjdhMzQ3Mi9yZW5k/ZXIuY29tLw",
      },
      {
        name: "VS Code",
        image:
          "https://imgs.search.brave.com/7yIshSgFWorSSY4kDlD4asCTBVzCsV_Hf8_YRhWcRKg/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy90/aHVtYi85LzlhL1Zp/c3VhbF9TdHVkaW9f/Q29kZV8xLjM1X2lj/b24uc3ZnLzI1MHB4/LVZpc3VhbF9TdHVk/aW9fQ29kZV8xLjM1/X2ljb24uc3ZnLnBu/Zw",
      },
      {
        name: "Figma",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSoUX5LMRa7atIsNfl0nP3DaUaV4URhV0PHfA&s",
      },
    ],
  },
  {
    title: "Desktop Applications",
    skills: [
      {
        name: "Tauri",
        image:
          "https://imgs.search.brave.com/qnLWef2LzPwAbg2T80U4RR_H3XH58LEk_3YV27_TMfU/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/YnJhbmRmZXRjaC5p/by9pZHpxVHJwc2s2/L3cvMjUyL2gvMjUy/L3RoZW1lL2Rhcmsv/aWNvbi5wbmc_Yz0x/YnhpZDY0TXVwN2Fj/emV3U0FZTVgmdD0x/NzY1Nzc5MTMxNTQ0",
      },
    ],
  },
];

export const experiences = [
  {
    id: 5,
    img: "https://www.qryptshield.com/logo.png",
    role: "Software Developer",
    company: "Qryptshield Technologies Pvt. Ltd.",
    date: "January 2026 - Present",
  },
  {
    id: 4,
    img: "https://media.licdn.com/dms/image/v2/D5603AQFWkM1iZ_SKsw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1718295133484?e=1776297600&v=beta&t=3QioZgXV5xzXnzO_geN9v2iZOUiSH6TDvqVK6Kx2II8",
    role: "Full Stack Developer Intern",
    company: "Advisions Research and Development",
    date: "April 2025 - November 2025",
  },
  {
    id: 1,
    img: "https://www.mentorle.in/mentorlelogo.png",
    role: "Frontend Developer Intern",
    company: "Mentorle",
    date: "November 2024 - March 2025",
  },
  {
    id: 2,
    img: "https://github.blog/wp-content/uploads/2022/10/hacktoberfestbanner.jpeg?resize=1200%2C630",
    role: "Open Source Contributor ",
    company: "Hacktoberfest 2024",
    date: "Octomber 2024",
    desc: "Contributing to different open-source projects and learn from industry experts",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023",
    desc: "Contributing to different open-source projects and learn from industry experts",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpOHZICt6EVYYLdri1FRDf8Ty0ou9cFFdEE7YxOEdTN8Un9-wmf5KT4cJounL-jUKr&usqp=CAU",
    school: "Gyan Ganga Institute of Technology and Sciences, Jabalpur",
    date: "2022 - 2026",
    grade: "7.6 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Design at Gyan Ganga Institute of Technology and Sciences, Jabalpur.",
    degree: "Bachelor of Technology - BTech, Computer Science and Design",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTV1Tdptjl_e56JB5UhK-08hxEM6u8YGIjHRQ&s",
    school: "Maharishi Vidya Mandir",
    date: "2021  - 2022",
    desc: "I completed my class 12 high school education at Maharishi Vidya Mandir, Seoni Madhya Pradesh",
    degree: "CBSE (XII), Science with Computer",
  },
];

export const projects = [
  {
    id: 12,
    title: "Latency Topology Visualizer",
    description:
      "A project focused on visualizing network latency across different geographical locations.",
    tags: [
      "Next Js",
      "Tailwind CSS",
      "Three Js",
      "TypeScript",
      "Shadcn UI",
      "API",
      "Vercel",
    ],
    category: "web app",
    github: "https://github.com/Sujal942/Latency-Topology-Visualizer",
    webapp: "https://latency-topology-visualizer-ochre.vercel.app/",
  },
  {
    id: 12,
    title: "EEG Brain Signal Analysis Platform",
    description:
      "An advanced EEG brain signal analysis platform for visualizing, analyzing, and detecting neurological abnormalities from EEG data.",
    tags: [
      "Python",
      "Streamlit",
      "NumPy",
      "Pandas",
      "Matplotlib",
      "SciPy",
      "MNE",
      "Scikit-learn",
    ],
    category: "web app",
    webapp: "https://eeg-prediction-app.streamlit.app/",
  },
  {
    id: 12,
    title: "DuraCrop",
    description:
      "DuraCrop – Face Crop Jet is an intelligent image processing tool that automates high-quality face cropping with multiple crop modes and customizable dimensions. It supports batch processing, lossless image formats, automatic brightness and contrast adjustment, and organized output management, all through a compact and user friendly interface designed for fast and professional workflows.",
    tags: ["Python", "tkinter", "OpenCV", "Face Detection"],
    category: "machine learning",
  },
  {
    id: 1,
    title: "Ai Waqueel (frontEnd-Legal)",
    description:
      "This service offers legal guidance for understanding court cases and consultations",
    tags: [
      "React Js",
      "Python",
      "Node Js",
      "Hugging Face (Data Set)",
      "GIT",
      "Github",
      "API",
      "Vercel",
      "Streamlit",
    ],
    category: "web app",
    github: "https://github.com/Sujal942/frontEnd-Legal",
    webapp: "https://front-end-legal.vercel.app",
  },
  {
    id: 2,
    title: "GitHub Profile Readme Generator",
    description:
      "GitHub Profile Readme Generator allow users to easily customize and copy their GitHub profile Readme..",
    tags: ["React Js", "Tailwind CSS", "API", "Vercel"],
    category: "web app",
    github: "https://github.com/Sujal942/react-github-readme-generator",
    webapp: "https://react-github-readme-generator.vercel.app",
  },
  {
    id: 3,
    title: "Kisan 360",
    description:
      "The platform allows users to search for medicine, fertilizers, and pesticides based on crop type and disease, using a clean and intuitive interface.",

    tags: ["Python", "Streamlit", "Generative AI", "API"],
    category: "web app",
    github: "https://github.com/Sujal942/Kisan-360_team_Ignite",
    webapp: "https://sujal942-kisan-360-team-ignite-app-8phtzq.streamlit.app/",
  },
  {
    id: 4,
    title: "Food WebApp",
    description: "Online meal ordering via the food web app.",
    tags: [
      "React Js",
      "Tailwind CSS",
      "RazorPay Payment Gateway",
      "Vercel",
      "Toastify",
      "Recoil",
    ],
    category: "web app",
    github: "https://github.com/Sujal942/OIBSIP_PIZZA-SHOP",
    webapp: "https://oibsip-pizza-shop.vercel.app/",
  },
  {
    id: 8,
    title: "Line Art Generator",
    description:
      "Built a Python-based tool that converts photos into minimal line art for sketching and printing.",
    tags: ["Python", "Streamlit"],
    category: "web app",
    github: "https://github.com/Sujal942/LineArt-Generator",
    webapp: "https://lineart-generator.streamlit.app/",
  },
  {
    id: 5,
    title: "MetaCode IDE",
    description:
      "A platform that allows teachers and students to share codes and communicate online.",
    tags: [
      "React Js",
      "Tailwind CSS",
      "SocketIO",
      "Express,",
      "Vercel",
      "API,",
      "GIT",
      "GitHub",
    ],
    category: "web app",
    github: "https://github.com/Sujal942/MetaCode",
    webapp: "https://meta-code-cyan.vercel.app",
  },
  {
    id: 11,
    title: "Vidhi Shiksha AI",
    description:
      "Vidhi Shiksha AI is an AI-powered legal education assistant designed to make law-related knowledge more accessible and understandable for students, professionals, and the general public. The platform uses natural language processing (NLP) to answer legal queries, explain complex legal terms, and summarize legal documents in simple language.",
    tags: [
      "React Js",
      "Express.js",
      "Node.js",
      "MongoDB",
      "Tailwind CSS",
      "Vercel",
      "API",
    ],
    category: "web app",
    // github: "https://github.com/Sujal942/Pokemon-App",
    webapp: "https://vidhi-shiksha-ai-3xct.vercel.app/",
  },
  {
    id: 6,
    title: "Pokemon App",
    description: "A platform that displays the different Pokemons.",
    tags: ["React Js", "Tailwind CSS", "Vercel", "API"],
    category: "web app",
    github: "https://github.com/Sujal942/Pokemon-App",
    webapp: "https://pokemon-app-six-ashy.vercel.app",
  },
  {
    id: 7,
    title: "Weather App",

    description:
      "A platform that displays the various weather conditions of different locations.",
    tags: ["React Js", "Tailwind CSS", "Vercel", "API"],
    category: "web app",
    github: "https://github.com/Sujal942/Weather-App",
    webapp: "https://weather-app-seven-iota-65.vercel.app",
  },
  {
    id: 9,
    title: "Ai Draw",

    description:
      "A platform that displays the various weather conditions of different locations.",
    tags: ["React Js", "Tailwind CSS", "HTML Canvas", "Vercel", "API"],
    category: "web app",
    github: "https://github.com/Sujal942/AiDraw",
    webapp: "https://ai-draw-ashy.vercel.app",
  },
  {
    id: 10,
    title: "File Sharing Platform",

    description:
      "A platform that allows users to Effortless File Sharing Fast, Secure, and Simple.",
    tags: ["React Js", "Tailwind CSS", "Express.js", "Node.js", "MongoDB"],
    category: "web app",
    github: "https://github.com/Sujal942/Minor-Project",
    webapp: "https://minor-project-nine-tau.vercel.app/",
  },
  {
    id: 13,
    title: "Contract Management System",
    description:
      "A full-stack contract management platform for drafting, tracking, and signing contracts with role-based access, versioning, and secure document storage.",
    tags: [
      "Next Js",
      "Python FastAPI",
      "MongoDB",
      "Tailwind CSS",
      "JWT",
      "REST API",
    ],
    category: "web app",
    github: "https://github.com/Sujal942/Hosho",
    webapp: " https://youtu.be/WmluHTEKQTw",
  },
  {
    id: 14,
    title: "Tauri Multi-Server Scanner",
    description:
      "A Tauri-based desktop application that performs parallel network scans across multiple servers, collecting latency and service health metrics with a lightweight Rust core, and detecting server cryptography (TLS versions, cipher suites, and certificate details).",
    tags: ["Tauri", "Rust", "Python", "Nmap", "Network Scan", "Desktop App"],
    category: "desktop app",
  },
];
